import React, { Fragment } from 'react'
import {
  SpacerVertical,
  Typography,
  Badge,
} from '@klarna/bubble-ui'
import styles from './PaymentMethod.css'
import config from '../../config'

type PaymentMethodProps = {
  purchaseAmount: string
  badge: string
  backgroundColorKey: string
  installmentAmount?: string
  frequencyTitle?: string
};

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  badge,
  backgroundColorKey,
  purchaseAmount,
  installmentAmount = '',
  frequencyTitle = '',
}) => {
  const {
    badgeColor, badgeTextColor
  } = config[backgroundColorKey]
  return (
    <Fragment>
      <style>{styles}</style>
      <div className="payment-method-container">
        <div id='left-content'>
          <Typography textToken="text-style/headings/blocks/medium/grande">
            {installmentAmount || purchaseAmount}
          </Typography>
          <SpacerVertical spaceToken="space.0" />
          <Typography textToken="text-style/text/labels/tiny/medium" colorToken="colors/text/neutral">
            {frequencyTitle}
          </Typography>
        </div>

        <div id='right-content'>
          <Badge backgroundColorToken={badgeColor} textColorToken="colors/text/default">
            <Typography textToken="text-style/text/paragraphs/tiny/medium"
              colorToken={badgeTextColor}>
              {badge}
            </Typography>
          </Badge>
        </div>
      </div>
    </Fragment>
  )
}

export default PaymentMethod
